import { useEffect } from "react";
const Reviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div
    className="elfsight-app-b3502ba5-20cf-45c0-943d-024a4b07fd7a"
    data-elfsight-app-lazy=""
  />
            </div>
        </section>;
};
export default Reviews;
